import React, { useEffect, useState } from 'react';
import $ from 'jquery-slim';
import { get } from 'lodash';
import { Outlet } from 'react-router-dom';
import { useDispatch } from "react-redux";

import { makeProfileData } from "../../actions/storage";
import Header from './Header';
import Footer from './Footer';
import AsyncGet from '../../components/AsyncGet';

import "../../assets/css/style.module.css";

const Layout = () => {
    const dispatch = useDispatch();
    const [dimesions, setDimensions] = useState({ height: 0, winWidth: window.innerWidth, winHeight: window.innerHeight });

    useEffect(() => {
        function updateDimensions() {
            setDimensions({
                winWidth: $(window).width(),
                winHeight: $(window).height() - $(`header`).outerHeight(),
            });
        }
        window.addEventListener('resize', updateDimensions);
        updateDimensions();
        return () => {
            window.removeEventListener('resize', updateDimensions);
        }
    }, []);

    return (
        <>
            <Header context={{ winHeight: dimesions.winHeight }} />
            <div className='contents'>
                <AsyncGet
                    url="/account"
                    permissionText={false}
                    loadOnMount={true}
                    showToastOnError={false}
                    onFetch={({data}) => {
                        if(get(data, 'id')){
                            dispatch(makeProfileData(data))
                        }
                    }}
                    render={() => {
                        return(
                            <Outlet context={{ height: dimesions.height, winWidth: dimesions.winWidth, winHeight: dimesions.winHeight }} />
                        )
                    }}
                />
            </div>
            <Footer />
        </>
    )
}

export default Layout;